
import { Component, Vue, Prop, Model, Emit } from "vue-property-decorator";

@Component({})
export default class TeamComponent extends Vue {
  name = "team";
}
